export default "__VITE_ASSET__CUn2vQOd__"